import {
  BOMBBOMB_INITIALIZE,
  BOMBBOMB_ERROR,
  BOMBBOMB_TOGGLE_OPEN,
  BOMBBOMB_MOUNT
} from 'src/actions/actionTypes'

const initialState = {
  initialized: false,
  open: false,
  mount: false,
  error: null
}

export default (state = initialState, { type, error }) => {
  switch (type) {
    case BOMBBOMB_INITIALIZE:
      return {
        ...state,
        initialized: true
      }

    case BOMBBOMB_ERROR:
      return {
        ...state,
        error
      }

    case BOMBBOMB_TOGGLE_OPEN:
      return {
        ...state,
        open: !state.open
      }

    case BOMBBOMB_MOUNT:
      return {
        ...state,
        open: true,
        mount: true
      }

    default:
      return state
  }
}
